'use client'

import { Skeleton } from "@/components/ui";
import { Loader2 } from "lucide-react";
import { useSelector } from "react-redux";
import { Dates, Times } from "./components";
import { useDateTime } from "./hooks";

interface TProps {
    eventInfo: any;
    onNext: () => void;
}

const DateTimeSelection = ({ eventInfo, onNext }: TProps) => {
    const cartData = useSelector(
        (state: any) => state?.user?.cart,
    );
    const { loading, dates, times, handleSelectDate, handleSelectTime }: any = useDateTime({ eventId: eventInfo?._id, cartData, onNext });

    return (
        <div className="w-full max-w-2xl p-4">
            <div className='mb-4 w-full max-w-2xl rounded-xl border bg-white p-3 text-center font-bold text-gray-800 uppercase'>
                {loading ? (
                    <Skeleton className='mx-auto h-5 w-[12rem] md:h-6' />
                ) : (
                    <p>Select Date</p>
                )}
            </div>
            <div className='mb-20 w-full max-w-2xl min-h-84 rounded-lg'>
                {loading ? (
                    <div className='flex w-full items-center justify-center py-10'>
                        <Loader2 className='h-8 w-8 animate-spin text-gray-500' />
                    </div>
                ) : (
                    <>
                        <Dates
                            dates={dates}
                            selectedDate={cartData?.selectedDate?.date}
                            handleSelectDate={handleSelectDate}
                        />

                        <Times
                            selectedDate={cartData?.selectedDate?.date}
                            times={times}
                            handleSelectTime={handleSelectTime}
                        />
                    </>
                )}
            </div>
        </div>
    );
}

export default DateTimeSelection;